import React from 'react';

import StorytellerUtils from 'lib/StorytellerUtils';
import { type ReactRendererProps } from '../shared/ComponentRegistry';

export const ComponentSpacer = ({ componentData }: ReactRendererProps) => {
  const typeClasses = StorytellerUtils.typeToClassesForComponentType(componentData.type);

  return <div className={`component ${typeClasses}`} />;
};
